import { createFileRoute } from '@tanstack/react-router';
import { EmptyState } from '@/components/page-header';
import { PackEditor } from '@/features/accountant/pack-editor';
import { usePack } from '@/lib/accountant';
import { useT } from '@/lib/i18n';

export const Route = createFileRoute('/reports/management/$packId')({ component: EditPack });

/** Screen A10 (document 06): edit a management report. */
function EditPack() {
  const { packId } = Route.useParams();
  const pack = usePack(packId);
  const t = useT();
  if (pack.isPending) return <p className="text-sm text-muted-foreground">{t('common.loading')}</p>;
  if (pack.isError)
    return (
      <EmptyState
        title={t('reportPages.reports.route.couldNotLoadPack')}
        hint={pack.error.message}
      />
    );
  return <PackEditor key={pack.data.id} pack={pack.data} />;
}
